$(function () {
	$('.header__burger, .header-nav__close').on('click', function () {
		$('body').toggleClass('show-menu');
		$('.header-nav').toggleClass('is-active');
	});
});